// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth"


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA3W7yedy3fvustoDhTbWszOO3aTzDM9HQ",
  authDomain: "pipay-ico.firebaseapp.com",
  projectId: "pipay-ico",
  storageBucket: "pipay-ico.firebasestorage.app",
  messagingSenderId: "742566948819",
  appId: "1:742566948819:web:507ad860d7964d3c45c926"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const dataBase = getAuth(app)